import { GameEvents } from '../GameEvents';
import type EventBus from '../EventBus';
import type { LevelDataService } from '../services/LevelDataService';
import SolutionPlayer from './SolutionPlayer';
import getLogger from '../logger';

const logger = getLogger('SolutionReplayMode');

export default class SolutionReplayMode {
  private state: any;
  private slice: any;
  private eventBus: EventBus;
  private dataService: LevelDataService;
  private solutionPlayer: any;

  constructor(state: any, slice: any, eventBus: EventBus, dataService: LevelDataService) {
    this.state = state;
    this.slice = slice;
    this.eventBus = eventBus;
    this.dataService = dataService;
    this.solutionPlayer = null;

    this.eventBus.on(GameEvents.LEVEL_STARTED, (payload: any) => this._onLevelStarted(payload));
    this.eventBus.on(GameEvents.SELECT_SOLUTION, (index: number) => this._onSelectSolution(index));
    this.eventBus.on(GameEvents.PLAY_NEXT_SOLUTION_STEP, () => this._onPlayNextStep());
    this.eventBus.on(GameEvents.ACTION_MODES_UPDATED, () => { this.slice.isPlayerTurn = true; });
    this.eventBus.on(GameEvents.PLAYER_ACTION_TAKEN, () => { this.slice.isPlayerTurn = false; });
    this.eventBus.on(GameEvents.RETURN_TO_HOME, () => this._reset());
  }

  async _onLevelStarted({ levelKey }: { levelKey: string }) {
    // Reset solution state for new level
    this._reset();
    this.solutionPlayer = new SolutionPlayer(this.eventBus);

    // Load solutions – same logic that was in LevelManager's dev block
    if (levelKey.startsWith('candidate:')) {
      // For candidates, solutions are embedded in the level data via entityManager.
      // entityManager is a global singleton; we can query it here.
      try {
        const entityManager = require('../entityManager').default;
        const solutionsEntity = entityManager.entities.find({ solutions: { $exists: true } });
        if (solutionsEntity && solutionsEntity.length > 0) {
          this.solutionPlayer.loadSolutions({ solutions: solutionsEntity[0].solutions });
        } else {
          this.solutionPlayer.loadSolutions(null);
        }
      } catch (e) {
        this.solutionPlayer.loadSolutions(null);
      }
    } else {
      const solutionData = this.dataService.getSolutionData(levelKey);
      this.solutionPlayer.loadSolutions(solutionData);
    }

    const count = this.solutionPlayer.getSolutionCount();
    this.slice.solutionCount = count;

    // Auto-select first solution
    if (count > 0) {
      this.solutionPlayer.selectSolution(0);
    }
  }

  _onSelectSolution(index: number) {
    if (this.solutionPlayer) {
      this.solutionPlayer.selectSolution(index);
    }
  }

  _onPlayNextStep() {
    if (this.solutionPlayer) {
      this.solutionPlayer.playNextStep();
    }
  }

  _reset() {
    this.slice.solutionCount = 0;
    this.slice.isPlayerTurn = false;
    this.solutionPlayer = null;
  }
}
